module.exports = __webpack_public_path__ + "img/crown.6954dde.webp";